<div class="conn-card">
    <app-report-top-filter-bar
        [paraReportName]="'hourly-sales-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()">
    </app-report-top-filter-bar>

    <div class="hourly-sales-mobile" *ngIf="useNewMobileLayout && dataList?.length > 0">
        <div class="hourly-sales-card" *ngFor="let product of dataList; let i = index">
            <div class="hourly-sales-card__header">
                <div class="hourly-sales-card__time">{{ formatHour(product.hour) }}</div>
                <div class="hourly-sales-card__location">{{ product.locationName }}</div>
            </div>
            <div class="hourly-sales-card__meta">
                <div class="hourly-sales-card__meta-item">
                    <span class="hourly-sales-card__meta-text">Invoices {{ product.invoiceCount | number }}</span>
                </div>
                <div class="hourly-sales-card__meta-item">
                    <span class="hourly-sales-card__meta-text">Items {{ product.salesItemCount | number }}</span>
                </div>
            </div>
            <button type="button" class="hourly-sales-card__toggle" (click)="toggleDetails(i)" [attr.aria-expanded]="isDetailsExpanded(i)">
                <span class="hourly-sales-card__toggle-label">
                    View Details
                    <span class="hourly-sales-card__chevron" [class.is-open]="isDetailsExpanded(i)">></span>
                </span>
                <span class="hourly-sales-card__amount">{{ product.grandTotal | currency | currencySpacing }}</span>
            </button>
            <div class="hourly-sales-card__details" *ngIf="isDetailsExpanded(i)">
                <div class="hourly-sales-card__detail-row">
                    <span>Return Items</span>
                    <span>{{ product.returnItemCount | number }}</span>
                </div>
                <div class="hourly-sales-card__detail-row">
                    <span>Void Items</span>
                    <span>{{ product.voidItemCount | number }}</span>
                </div>
                <div class="hourly-sales-card__detail-row">
                    <span>Cost of Goods</span>
                    <span>{{ product.totalCost | currency | currencySpacing }}</span>
                </div>
                <div class="hourly-sales-card__detail-row">
                    <span>Net Sale</span>
                    <span>{{ product.totalSale | currency | currencySpacing }}</span>
                </div>
                <div class="hourly-sales-card__detail-row">
                    <span>Sales Tax</span>
                    <span>{{ product.salesTax | currency | currencySpacing }}</span>
                </div>
                <div class="hourly-sales-card__detail-row hourly-sales-card__detail-row--total">
                    <span>Total Sales</span>
                    <span>{{ product.grandTotal | currency | currencySpacing }}</span>
                </div>
            </div>
        </div>

        <div class="hourly-sales-card hourly-sales-card--total">
            <div class="hourly-sales-card__header">
                <div class="hourly-sales-card__title">Day Total</div>
            </div>
            <div class="hourly-sales-card__meta">
                <div class="hourly-sales-card__meta-item">
                    <span class="hourly-sales-card__meta-text">Invoices {{ totalInvoiceCount | number }}</span>
                </div>
                <div class="hourly-sales-card__meta-item">
                    <span class="hourly-sales-card__meta-text">Items {{ totalSalesItemCount | number }}</span>
                </div>
            </div>
            <button type="button" class="hourly-sales-card__toggle" (click)="toggleTotalDetails()" [attr.aria-expanded]="totalDetailsExpanded">
                <span class="hourly-sales-card__toggle-label">
                    View Details
                    <span class="hourly-sales-card__chevron" [class.is-open]="totalDetailsExpanded">></span>
                </span>
                <span class="hourly-sales-card__amount">{{ totalGrandTotal | currency | currencySpacing }}</span>
            </button>
            <div class="hourly-sales-card__details" *ngIf="totalDetailsExpanded">
                <div class="hourly-sales-card__detail-row">
                    <span>Return Items</span>
                    <span>{{ totalReturnItemCount | number }}</span>
                </div>
                <div class="hourly-sales-card__detail-row">
                    <span>Void Items</span>
                    <span>{{ totalVoidItemCount | number }}</span>
                </div>
                <div class="hourly-sales-card__detail-row">
                    <span>Cost of Goods</span>
                    <span>{{ totalCostAmount | currency | currencySpacing }}</span>
                </div>
                <div class="hourly-sales-card__detail-row">
                    <span>Net Sale</span>
                    <span>{{ totalSalesAmount | currency | currencySpacing }}</span>
                </div>
                <div class="hourly-sales-card__detail-row">
                    <span>Sales Tax</span>
                    <span>{{ totalSalesTax | currency | currencySpacing }}</span>
                </div>
                <div class="hourly-sales-card__detail-row hourly-sales-card__detail-row--total">
                    <span>Total Sales</span>
                    <span>{{ totalGrandTotal | currency | currencySpacing }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="hourly-sales-table" [class.hourly-sales-table-hidden]="useNewMobileLayout">
        <p-table [value]="dataList" dataKey="name" #dt [columns]="csvcols" styleClass="p-datatable-striped" [tableStyle]="{ width: 'max-content' }"  [autoLayout]="true"  responsiveLayout="scroll" *ngIf="dataList?.length > 0">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="vertical-align: middle" [style.text-align]="i < 2 ? 'left' : 'right'" *ngFor="let col of domColHeader; let i = index">
                            <strong>{{col}}</strong>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-expanded="expanded">
                    <tr>
                        <td style="text-align: left; vertical-align: middle">{{ product.locationName }}</td>
                        <td style="text-align: left; vertical-align: middle">
                            <span *ngIf="product.hour > -1">
                                <span *ngIf="product.hour < 12">{{product.hour}} AM</span>
                                <span *ngIf="product.hour == 12">{{product.hour}} PM</span>
                                <span *ngIf="product.hour > 12">{{product.hour -12}} PM</span>
                            </span>
                        </td>
                        <td style="text-align: right; vertical-align: middle">{{ product.invoiceCount | number }}</td>
                        <td style="text-align: right; vertical-align: middle">{{ product.salesItemCount | number }}</td>
                        <td style="text-align: right; vertical-align: middle">{{ product.returnItemCount | number }}</td>
                        <td style="text-align: right; vertical-align: middle">{{ product.voidItemCount | number }}</td>
                        <td style="text-align: right; vertical-align: middle">{{ product.totalCost | currency | currencySpacing }}</td>
                        <td style="text-align: right; vertical-align: middle">{{ product.totalSale | currency | currencySpacing }}</td>
                        <td style="text-align: right; vertical-align: middle">{{ product.salesTax | currency | currencySpacing }}</td>
                        <td style="text-align: right; vertical-align: middle">{{ product.grandTotal | currency | currencySpacing }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr *ngIf="dataList?.length > 0">
                        <td colspan="2" style="text-align: left; vertical-align: middle"><strong>Total</strong></td>
                        <td *ngFor="let col of domSummaryflds" style="text-align: right; vertical-align: middle">{{calculateSummaryTotal(col)}}</td>
                    </tr>
                </ng-template>
        </p-table>
    </div>
    <div class="flex" *ngIf="dataList?.length==0">
        <div class="flex justify-content-center" style="width: 100%">
            <span class="control-description text-muted text-align-center"> No data found!</span>
        </div>
    </div>
</div>
